import type {MenuItemConfig} from '@myparcel-frontend/ui';

export const getDividerMenuItem = ({label}: {label: string}): MenuItemConfig => ({
  type: 'divider',
  label,
});
